



























































































import { Inject } from '@cds/common';
import moment from 'moment';
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';
import ArticleModulePopup from './ArticleModulePopup.vue';

@Component({
  components: {
    ArticleModulePopup,
  }
})
export default class ArticleModule extends Vue {
  public queryForm: Record<string, any> = {
    pages: 1,
    size: 10,
    current: 1,
    total: 0,
    name: '',
    modelCode: '',
    createTimeRange: [],
  }
  public isShowPopup: Boolean = false; // 是否显示主目录popup
  public popupId: String = null; // uuid
  public tableData: any[] = [];
  public loading: Boolean = true;

  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;

  public async created(): Promise<void> {
    this.queryForm = {
      pages: 1,
      size: 10,
      current: 1,
      total: 0,
      name: '',
      modelCode: '',
      createTimeRange: [],
    }
    await this.getList();
  }

  //查询接口
  public search() {
    this.queryForm.current = 1;
    this.getList()
  }

  //分页相关
  public handleSizeChange(size: number) {
    this.queryForm.size = size;
    this.getList();
  }

  public handleCurrentChange(current: number) {
    this.queryForm.current = current;
    this.getList();
  }

  //获取数据接口
  public async getList() {
    this.loading = true;
    let params: any = {
      name: this.queryForm.name || '',
      modelCode: this.queryForm.moduleType || '',
      createDateStart: (this.queryForm.createTimeRange || [])[0],
      createDateEnd: (this.queryForm.createTimeRange || [])[1],
      current: this.queryForm.current,
      size: this.queryForm.size
    };

    try {
      const res = await this.nuoxiaoerService.fetchLibraryModuleList(params);
      console.log(res)
      this.loading = false;

      const dict = {
        'application' : '应用',
        'scenarios' : '业务场景',
        'novartis_video' : '诺华视界',
      }
      const list = (res.records || []).map(x => {
        return {
          ...x,
          userNames:x.userNames?x.userNames.join(','):'',
          createdTime: x.createdTime ? moment(x.createdTime).format('YYYY-MM-DD HH:mm:ss') : '--',
          moduleTypeName: dict[x.modelCode] || '',
          // 处理用户组展示
          userGroupNames: (x.userGroups||[]).map((g: any) => g.groupName).join(', '),
        }
      });
      this.tableData = list;

      this.queryForm.total = res.total || 0;
      this.queryForm.pages = res.pages || 0;
      this.queryForm.size = res.size || 10;
      this.queryForm.current = res.current || 1;
    } catch (error) {
      this.loading = false;
      console.error('获取文库模块列表失败：', error);
      this.$message.error('获取列表数据失败，请稍后重试');
    }
  }

  //删除接口
  private async handleDelete(row: any): Promise<void> {
    console.log('点击删除', row);
    // 判断该封面是否有挂靠的目录
    // if (row.hasDirectories) {
    //   this.$message({
    //     type: 'warning',
    //     message: '请确认该封面下没有关联目录后方可删除该封面'
    //   });
    //   return;
    // }

    try {
      await this.$confirm('是否删除该信息？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      });
      // 删除数据
      const res = await this.nuoxiaoerService.deleteLibraryModule({ id: row.id }, {headers: {needResponse: true}})
      console.log('删除接口返回res=============',res )
      const code = res && res.header && res.header.code;
      if (code !== 200) {
        throw new Error(res.header.message || '删除失败');
      }
      this.$message({
        message: '删除成功',
        type: 'success'
      });
      // 刷新列表
      this.getList();
    } catch (error) {
      if (error === 'cancel') {
        // 用户取消操作，不做处理
        return;
      }
      console.error('删除接口返回：', error);
      this.$message.error('删除失败：' + (error.message || '未知错误'));
    }
  }

  //重置
  public reset() {
    this.queryForm = {
      pages: 1,
      size: 10,
      current: 1,
      total: 0,
      name: '',
      modelCode: '',
      createTimeRange: [],
    };
    this.getList()
  }


  /* 打开popup */
  public handleOpenPopup(rowData:any) {
    if (!rowData) {
      console.log('新增');
      this.popupId = null;
      this.isShowPopup = true;
    } else {
      console.log('编辑 rowData:', rowData);
      this.popupId = rowData.id;
      this.isShowPopup = true;
    }
  }

  /* 保存后 */
  public handleAfterSaved() {
    console.log('handleAfterSaved');
    this.getList();
    this.isShowPopup = false;
    this.popupId = null;
  }

  /* 取消popup */
  public handleCancelPopup() {
    console.log('handleCancelPopup');
    this.isShowPopup = false;
    this.popupId = null;
  }

   /* 关闭popup后 */
  public handleAfterClosePopup() {
    console.log('handleAfterClosePopup');
    this.popupId = null;
  }


}
